export default function (text) {
    text = text.toString().trim();

    const from = "ąàáäâãćęèéëêìíïîłńòóöôõśùúüûñçżźĄÀÁÄÂÃĆĘÈÉËÊÌÍÏÎŁŃÒÓÖÔÕŚÙÚÜÛÑÇŻŹ";
    const to   = "aaaaaaceeeeeiiiilnooooosuuuunczzAAAAAACEEEEEIIIILNOOOOOSUUUUNCZZ";

    for (let i = 0, len = from.length; i < len; i++) {
        text = text.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
    }

    return text
        .replace(/[^a-zA-Z0-9]/g, "") // usuń znaki specjalne
}
